import { AiOutlineDashboard } from 'react-icons/ai';
import { HiOutlineDocumentText } from 'react-icons/hi';
import { MdOutlineAddBox } from 'react-icons/md';
import { FiSettings } from 'react-icons/fi';

// Menu of the module. path: relative to /{tenant}/contracts ('' = the dashboard). labelKey: a key of the
// "contracts" namespace. adminOnly: hidden from users whose role in the app is "user".
export const contractsMenu = [
    { path: '', labelKey: 'menu.dashboard', Icon: AiOutlineDashboard, end: true },
    { path: 'list', labelKey: 'menu.contracts', Icon: HiOutlineDocumentText, end: true },
    { path: 'create', labelKey: 'menu.newContract', Icon: MdOutlineAddBox, end: true },
    { path: 'settings', labelKey: 'menu.settings', Icon: FiSettings, end: true, adminOnly: true },
];
